import React, { useCallback, useState } from 'react'
import {
	Icons,
	Modal,
	ModalSection,
	Row,
	SearchInput,
	Typography,
	PrimaryButton,
} from '@copyrightagent/basic-components'
import { blue } from '../../../../lib/Colors'
import { Button } from '@material-ui/core'
import { useDropzone } from 'react-dropzone'
import globalUseStyle from '../style'
import useStyle from './UploadTransferAgreementModalStyle'
import { uploadTransferAgreement } from '../api'
import { toast } from '../../../../store/utils'
import { useTransferAgreementsStore } from '../stores/transferAgreementStore'
import Response from 'lib/http/Response'

export const UploadTransferAgreementModal = ({
	uploadSuccessCallback,
}: {
	uploadSuccessCallback: (response: Response) => void
}) => {
	const {
		fetchTransferAgreements,
		setTransferAgreementModalOpen,
		uploadTransferAgreementModalOpen,
	} = useTransferAgreementsStore()

	const globalClasses = globalUseStyle()
	const classes = useStyle()

	const [uploading, setUploading] = useState(false)
	const [photographerName, setPhotographerName] = useState('')
	const [file, setFile] = useState<File | null>(null)

	const handleClose = () => {
		setPhotographerName('')
		setTransferAgreementModalOpen(false)
		setUploading(false)
		setFile(null)
	}

	const onDrop = useCallback((acceptedFile) => {
		setFile(acceptedFile[0])
	}, [])

	const { getRootProps, getInputProps } = useDropzone({
		accept: 'application/pdf',
		onDrop,
	})

	const handleSubmit = async () => {
		setUploading(true)
		const response = await uploadTransferAgreement({
			photographerName,
			file,
		})
		setUploading(false)

		if (response.isSuccessful) {
			handleClose()
			fetchTransferAgreements({ isInitialLoad: true })
			uploadSuccessCallback(response)
			await toast(
				'Transfer of Rights Agreement uploaded successfully',
				'success',
			)
			return
		}

		await toast('Something went wrong. Please try again later', 'error')
	}

	return (
		<Modal
			open={uploadTransferAgreementModalOpen}
			onClose={handleClose}
			title={'Upload Transfer Of Rights Agreement'}
			titleText={
				'Upload your transfer of rights agreement by inputting the photographer name and uploading the agreement in .PDF format.'
			}
			size="large"
		>
			<ModalSection>
				<Typography variant="body2">Photographer Name</Typography>
				<div className={classes.uploadInput}>
					<SearchInput
						onChange={(e) => setPhotographerName(e.target.value)}
						placeholder={'Photographer Name'}
					/>
				</div>
				<div {...getRootProps({ className: classes.uploadDropzone })}>
					<input {...getInputProps()} />
					<Icons.UploadIcon color={blue} />
					{file ? (
						<>
							<br />
							<Typography fontColor={blue} variant="body2">
								File selected
							</Typography>
							<br />
							<Typography fontColor={blue} variant="body2">
								{file.name}
							</Typography>
						</>
					) : (
						<>
							<br />
							<Typography fontColor={blue} variant="body2">
								Drop file here
							</Typography>
							<br />
							<Typography fontColor={blue} variant="body2">
								Supports: .PDF
							</Typography>
						</>
					)}
				</div>
			</ModalSection>
			<ModalSection>
				<Row justify="flex-end">
					<Button
						className={globalClasses.invisibleButton}
						onClick={handleClose}
					>
						<Typography>Cancel</Typography>
					</Button>
					<PrimaryButton
						type="submit"
						loading={uploading}
						text={'Upload Agreement'}
						loadingText={'Uploading Agreement'}
						onClick={handleSubmit}
						disabled={uploading || !photographerName || !file}
					/>
				</Row>
			</ModalSection>
		</Modal>
	)
}
